<div class="flex-auto flex items-center ml-l" style="background-color: white;">
  <a
    class="action flex-none textSub"
    color="secondary"
    id="get-vex"
    mat-flat-button>
    <mat-icon
      class="icon-sm ltr:mr-2 rtl:ml-2"
      svgIcon="mat:shopping_bag"></mat-icon>
    <span>Copyright {{year}} © All rights reserved</span>
  </a>
  <!-- <div class="font-medium ltr:ml-4 rtl:mr-4 hidden sm:block">
    Copyright {{year}} © DashCam
  </div> -->
</div>
